import React from 'react';
import { Modal, Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

interface CommentsModalProps {
	visible: boolean;
	title?: string;
	text?: string;
	onClose: () => void;
}

export const CommentsModal: React.FC<CommentsModalProps> = ({
	visible,
	title,
	text,
	onClose,
}) => {
	const { t } = useTranslation();

	return (
		<Modal
			open={visible}
			onCancel={onClose}
			title={
				<div className="w-full flex justify-center">
					<Text className="font-sans font-bold text-lg text-gray-650">
						{t(title || '')}
					</Text>
				</div>
			}
			centered
			footer={[
				<Button
					key="ok"
					type="primary"
					className="bg-blue-500 hover:bg-blue-600"
					onClick={onClose}
				>
					{t('ok')}
				</Button>,
			]}
			className="p-1"
		>
			<div className="mt-5 mb-1 font-sans text-sm font-normal text-gray-650">
				{t('comments')}
			</div>
			<div className="p-4 min-h-24 font-sans font-normal text-sm text-gray-650 rounded-md border border-solid !border-gray-200">
				{text}
			</div>
		</Modal>
	);
};
